import $store from '@/store'
import lang from '@/lang'
import ColumnUtils from '@/utils/ColumnUtils'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import StrUtils from '@/utils/StrUtils'

/**
 * 一个参数
 */
export const ERROR_MESSAGE_1 = ['EMPTY_DATATABLE', 'NO_CONFIGURATION_CHARGES', 'NOT_ALLOWED_UPLOAD', 'NO_FIELD']
/**
 * 两个参数
 */
export const ERROR_MESSAGE_2 = ['NO_OF', 'NO_SUM', 'EQ_TYPE_SIZE', 'COMMON_ERROR', 'VALIDITY_ERROR', 'SUM_NOT_EQUAL', 'VALIDITY_LESS', 'NOT_ALLOWED_NEGATIVE', 'IS_EMPTY', 'RATE_TYPE_ERROR']
/**
 * 三个参数
 */
export const ERROR_MESSAGE_3 = ['CHARGES', 'IS_SAME', 'BOTH_EMPTY', 'FIELD_TOO_LONG', 'IS_LESS', 'MUST_EMPTY', 'EXISTS_SAME_TIME', 'FORMAT_NOT_MATCHING', 'EXIST_THE_SAME_TIME']

export class PriceUploadExceptionUtil {
  static handleError(uploadException) {
    let message = ''
    if (uploadException === null) return ''
    const errors = uploadException.errors
    let sheets = uploadException.sheets
    let sheetCount = uploadException.sheetCount
    let sheetName = ''
    let sheetErrors = null
    let index = 1
    if (sheetCount < 1 && uploadException.errorCount > 0) {
      sheetCount = 1
      sheets = [uploadException.activeSheet]
    }
    for (let j = 0; j < sheetCount; j++) {
      sheetName = sheets[j]
      if (errors.hasOwnProperty(sheetName)) {
        sheetErrors = errors[sheetName]
        message += (index++).toString() + '.' + sheetName + ':<br/>'
        for (const errMsg of ERROR_MESSAGE_1) {
          if (sheetErrors.hasOwnProperty(errMsg)) {
            message += this.getSheetMessage1(sheetErrors[errMsg], lang.t('Pricing.' + errMsg))
          }
        }
        for (const errMsg of ERROR_MESSAGE_2) {
          if (sheetErrors.hasOwnProperty(errMsg)) {
            message += this.getSheetMessage2(sheetErrors[errMsg], lang.t('Pricing.' + errMsg))
          }
        }
        for (const errMsg of ERROR_MESSAGE_3) {
          if (sheetErrors.hasOwnProperty(errMsg)) {
            message += this.getSheetMessage3(sheetErrors[errMsg], lang.t('Pricing.' + errMsg))
          }
        }
        if (sheetErrors.hasOwnProperty('REGION_NO_POL')) {
          message += this.getSheetMessageOfRegion(sheetErrors, 'REGION_NO_POL')
        } else if (sheetErrors.hasOwnProperty('REGION_NO_POD')) {
          message += this.getSheetMessageOfRegion(sheetErrors, 'REGION_NO_POD')
        }
      } else {
        if (errors.hasOwnProperty('DATABASE_ERROR')) {
          message = lang.t('Pricing.AirPriceServiceItem')
        }
      }
    }
    message += '<br/>'
    return message
  }

  static getSheetMessageOfRegion(sheetErrors, errorID) {
    let tmp = this.getSheetMessage2(sheetErrors[errorID], lang.t('Pricing', errorID))
    const temps = tmp.split('_')
    if (temps != null && temps.length === 5) {
      const isCN = $store.getters.language === 'zh'
      const rg = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Region, 'code', temps[1], isCN ? 'name' : 'nameEnglish')
      temps[1] = StrUtils.isEmpty(rg) ? '' : rg
      tmp = temps.join('')
    }
    return tmp
  }

  /**
   * 只是用msg一个字段
   */
  static getSheetMessage1(sheetError, source) {
    let msg = ''
    let tmp = ''
    for (const detail of sheetError) {
      tmp += detail.field + ','
    }
    tmp = tmp.substring(0, tmp.length - 1)
    msg = StrUtils.substitute(source, tmp)
    return msg
  }
  /**
   * 使用msg，row，col
   */
  static getSheetMessage2(sheetError, source) {
    let msg = ''
    let tmp = []
    const map = {}
    let rows = []
    const fields = []
    for (const detail of sheetError) {
      if (!map.hasOwnProperty(detail.field)) {
        rows = []
        fields.push(detail.field)
        map[detail.field] = rows
      }
      if (detail.hasOwnProperty('col')) {
        (map[detail.field]).push('[' + detail.row + ',' + detail.col + '] ')
      } else {
        (map[detail.field]).push('[' + detail.row + '] ')
      }
    }
    for (const field of fields) {
      tmp = []
      for (const row of map[field]) {
        tmp.push(row)
      }
      msg += StrUtils.substitute(source, tmp.join(','), field)
    }
    return msg
  }
  /**
   * 使用msg，row，而且msg包含两个信息
   */
  static getSheetMessage3(sheetError, source) {
    let msg = ''
    for (const detail of sheetError) {
      msg += StrUtils.substitute(source, '[' + detail.row + '] ', detail.field, detail.msg)
    }
    return msg
  }
}
